import React from 'react';
import { iconStyle } from './styles';

export const Pig: React.FC<{ size?: string }> = ({ size }) => {
  return (
    <div style={iconStyle(size)}>
      <svg
        width="113px"
        height="113px"
        viewBox="0 0 113 113"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g transform="translate(-284.000000, -757.000000)">
            <g transform="translate(155.000000, 632.000000)">
              <g transform="translate(120.000000, 116.000000)">
                <g transform="translate(9.000000, 9.000000)">
                  <circle
                    fill="#500F71"
                    cx="56.5"
                    cy="56.5"
                    r="56.5"
                  ></circle>
                  <g
                    transform="translate(20.000000, 22.000000)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <g transform="translate(10.882353, 6.363636)">
                      <path
                        d="M27.2064756,25.4545455 C22.9992991,25.4545455 19.5882353,28.7781082 19.5882353,32.8787879 C19.5882353,36.9794676 22.9992991,40.3030303 27.2064756,40.3030303 C31.4124656,40.3030303 34.8235294,36.9794676 34.8235294,32.8787879 C34.8235294,28.7781082 31.4124656,25.4545455 27.2064756,25.4545455 Z"
                        id="Stroke-1"
                      ></path>
                      <path
                        d="M44.7732753,11.1361468 L44.7732753,1.85602447 C44.7732753,0.830296304 44.0758904,0 43.2204315,0 C39.4603644,0 36.7196416,1.20728321 35.7909573,5.55419659 C32.7991759,4.36772861 29.5354144,3.71204894 26.1170659,3.71204894 C23.3112538,3.71204894 20.6077249,4.15379432 18.0715683,4.97021381 C16.8186001,1.10205067 13.6257394,0 9.32752354,0 C8.29888075,0 7.46085652,0.830296304 7.46085652,1.85602447 L7.46085652,11.1361468 C7.46085652,11.2564126 7.47596653,11.3674271 7.49921269,11.4807545 C2.85927824,16.1688063 0,22.5995553 0,29.6975479 C0,38.52783 4.42606974,46.326602 11.1918659,51.0239051 L11.1918659,57.5379149 C11.1918659,58.5647995 12.0310525,59.3939394 13.058533,59.3939394 L20.5205518,59.3939394 C21.5515192,59.3939394 22.3860565,58.5647995 22.3860565,57.5379149 L22.3860565,55.4170745 C23.6029932,55.5916911 24.8489876,55.6818905 26.1170659,55.6818905 C27.3851442,55.6818905 28.6311386,55.5916911 29.8480753,55.4170745 L29.8480753,57.5379149 C29.8480753,58.5647995 30.6860996,59.3939394 31.71358,59.3939394 L39.1767612,59.3939394 C40.2065663,59.3939394 41.0411036,58.5647995 41.0411036,57.5379149 L41.0411036,51.0239051 C47.8068998,46.326602 52.2352941,38.52783 52.2352941,29.6975479 C52.2352941,22.6030245 49.3783405,16.1711191 44.7442176,11.4842237 C44.7616522,11.3720527 44.7732753,11.2564126 44.7732753,11.1361468 Z"
                        id="Stroke-3"
                      ></path>
                      <path
                        d="M30.4705882,4.24242424 L30.4705882,11.8080042 C30.4705882,12.3154404 29.7020221,12.7272727 28.7702206,12.7272727 L25.6415441,12.7272727 C24.7063419,12.7272727 23.9411765,12.3154404 23.9411765,11.8080042 L23.9411765,4.24242424"
                        id="Stroke-5"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
